import { awaitTimeout } from "./timers";

/**
 * Maps items with an async function, running at most `limit` at the same time
 * Keeps the order of the items; like Promise.allSettled, it never rejects
 */
export const mapSettledWithLimit = async (items, limit, fn) => {
  const results = new Array(items.length);
  let next = 0;
  const worker = async () => {
    while (next < items.length) {
      const index = next++;
      try {
        results[index] = { status: "fulfilled", value: await fn(items[index], index) };
      } catch (reason) {
        results[index] = { status: "rejected", reason };
      }
    }
  };
  await Promise.all(Array.from({ length: Math.min(limit, items.length) }, worker));
  return results;
};

/**
 * Calls fn again after a pause when it fails (rate limits and node hiccups are usually transient)
 */
export const withRetry = async (fn, { retries = 2, delay = 400 } = {}) => {
  for (let attempt = 0; ; attempt++) {
    try {
      return await fn();
    } catch (error) {
      if (attempt >= retries) throw error;
      await awaitTimeout(delay * (attempt + 1));
    }
  }
};
